import {renderHook} from '@testing-library/react';

import {AnyFunction} from 'shared/web';

import {HookMockProvider} from '../components/HookMockProvider/HookMockProvider';
import {ProvidersConfig} from '../components/HookMockProvider/ProvidersConfig';

export const renderHookWithProviders = (hook: AnyFunction, config: ProvidersConfig = {}) =>
  renderHook(hook, {
    wrapper: ({children}) => (
      <HookMockProvider memoryRouterProps={config.memoryRouterProps} language={config.language}>
        {children}
      </HookMockProvider>
    ),
  });
